
module.exports = function Personaliser ($host, config) {

  // Dom
  var $message   = $('textarea', $host);
  var $charLimit = $('[data-char-limit]', $host);

  // State
  config.msgCharLimit = parseInt(config.msgCharLimit);

  // Functions
  function checkMessageLimit () {
    var msg = $message.val();

    if (msg.length > config.msgCharLimit) {
      $message.val(msg.substr(0, config.msgCharLimit));
    }

    var remaining = config.msgCharLimit - msg.length;
    $charLimit.text(remaining);
  }

  // Listeners
  $message.on('change keydown keyup paste focus blur', checkMessageLimit);

}

